import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import i18next from "i18next";
import { initReactI18next, I18nextProvider } from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import { client } from "./graphql/client";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./index.css";
import global_es from "./translations/es/global.json";
import global_en from "./translations/en/global.json";
import { AuthProvider } from "./contexts/authContext";
import { initSentry } from "./utils/sentry";
import * as Sentry from "@sentry/react";

// Suprimir error benigno de ResizeObserver (común con MUI/Recharts)
window.addEventListener("error", (e) => {
  if (
    e.message &&
    (e.message.includes("ResizeObserver loop completed with undelivered notifications") ||
      e.message.includes("ResizeObserver loop limit exceeded"))
  ) {
    e.stopImmediatePropagation();
    return true;
  }
  return false;
});

// Inicializar Sentry antes que cualquier otra cosa
initSentry({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENV || process.env.NODE_ENV || "development",
  release: process.env.REACT_APP_VERSION || "0.1.0",
});

const storedFlag = localStorage.getItem("language");

i18next.use(initReactI18next).init({
  interpolation: { escapeValue: false },
  lng: storedFlag ? storedFlag : "es",
  resources: {
    en: {
      global: global_en,
    },
    es: {
      global: global_es,
    },
  },
});

// Componente de fallback para errores
const ErrorFallback = ({ error, resetError }) => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    height: '100vh',
    padding: '20px',
    textAlign: 'center'
  }}>
    <h2>Algo salió mal</h2>
    <p>Ha ocurrido un error inesperado. Por favor, recarga la página.</p>
    <button onClick={resetError} style={{ 
      marginTop: '20px', 
      padding: '10px 20px',
      cursor: 'pointer'
    }}>
      Intentar de nuevo
    </button>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <I18nextProvider i18n={i18next}>
            <ApolloProvider client={client}>
              <App />
            </ApolloProvider>
          </I18nextProvider>
        </AuthProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
